(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ask-a-question-modal"] && !Shopify.designMode) return;
  try {
    const hash = window.location.hash;
  const formId = document.querySelector('.ask-a-question__form').id;
  const dialogComponent = document.getElementById('ask-a-question-modal');
  const dialog = dialogComponent.querySelector('dialog');
  if (hash.includes(formId)) {
    dialog.showModal();
  }
  } catch(e) { console.error(e); }
})();

})();
